export enum TableIdentifier {
    WorkRequests = "workRequests",
    WorkOrders = "workOrders",
    ServiceQuotes = "serviceQuotes",
}
